const colors = [
  '#ef4444',
  '#f97316',
  '#facc15',
  '#22c55e',
  '#06b6d4',
  '#3b82f6',
  '#a855f7',
  '#78716c',
  '#e93a3a80',
  '#f36d0e80',
  '#f4c60d80',
  '#23b75980',
  '#0ba9c580',
  '#337bf080',
  '#a049f280'
]

export default {
  methods: {
    /**
     * Возвращает цветовой код, следующий от указанной позиции
     * @param i Позиция
     * @returns {string}
     */
    getNextColor (i) {
      return colors[i % colors.length]
    }
  }
}
